import { post } from "../utils/api/apiCaller";
import { ENDPOINTS } from "../utils/api/endpoints";
import type { ApiResponse } from "../utils/api/apiClient";

export const loginUser = (
  email: string,
  password: string,
  location?: string,
  role?: string,
): Promise<ApiResponse> =>
  post(ENDPOINTS.AUTH.LOGIN, {
    email,
    password,
    ...(location && { location }),
    ...(role && { role }),
  });

export const logoutUser = (refreshToken: string): Promise<ApiResponse> =>
  post(ENDPOINTS.AUTH.LOGOUT, { refreshToken });

export const refreshToken = (refreshToken: string): Promise<ApiResponse> =>
  post(ENDPOINTS.AUTH.REFRESH, { refreshToken });

export const verify2fa = (
  otp: string,
  token: string,
  location?: string,
): Promise<ApiResponse> =>
  post(
    ENDPOINTS.AUTH.VERIFY_2FA,
    { otp, ...(location && { location }) },
    { "x-2fa-token": token },
  );

export const resend2fa = (token: string): Promise<ApiResponse> =>
  post(ENDPOINTS.AUTH.RESEND_2FA, undefined, { "x-2fa-token": token });

export const loginAsUser = (userId: string): Promise<ApiResponse> =>
  post(ENDPOINTS.AUTH.LOGIN_AS(userId), {});
